import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, Input, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslocoModule } from '@jsverse/transloco';

import { CapitalizePipe } from '@hmax-order/frontend/utils';

/** Por quanto tempo o ✓ fica visível depois de copiar. Curto o bastante para não parecer estado. */
const COPIED_FEEDBACK_MS = 2_000;

@Component({
  selector: 'hmax-button-copy-value',
  standalone: true,
  templateUrl: './button-copy-value.component.html',
  styleUrls: ['./button-copy-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, TranslocoModule, ClipboardModule, CapitalizePipe],
})
export class ButtonCopyValueComponent {
  @Input() label?: string;
  @Input() value?: string;
  @Input() tooltipPosition: 'above' | 'below' | 'left' | 'right' | 'before' | 'after' = 'above';

  /** `true` por alguns segundos depois de copiar — troca o ícone de prancheta por ✓. */
  readonly copied = signal(false);

  private timer?: ReturnType<typeof setTimeout>;

  constructor() {
    // Sem isto, o timer pendente chama `set` num componente já destruído (o diálogo do segredo fecha
    // logo depois de copiar, que é justamente o caso comum deste botão).
    inject(DestroyRef).onDestroy(() => clearTimeout(this.timer));
  }

  markCopied(): void {
    this.copied.set(true);
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.copied.set(false), COPIED_FEEDBACK_MS);
  }
}
